export default {"src":"/uk/_next/static/media/Success.4d49cc05.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};